import { useEffect, useState } from "react";
import api, { fmtErr } from "../../api";
import Layout from "../../components/Layout";
import { toast } from "sonner";
import { JobForm } from "../../components/JobForm";

export default function JobNew() {
  const [properties, setProperties] = useState([]);
  const [taxCfg, setTaxCfg] = useState(null);

  useEffect(() => {
    api.get("/properties").then((r) => setProperties(r.data.filter((p) => p.active !== false))).catch((e) => toast.error(fmtErr(e)));
    api.get("/settings").then((r) => setTaxCfg({ enabled: r.data.tax_enabled, rate: r.data.tax_rate, label: r.data.tax_label || "HST" })).catch(() => {});
  }, []);

  return (
    <Layout title="New project quote">
      <JobForm properties={properties} taxCfg={taxCfg} testid="job-new" />
    </Layout>
  );
}
